import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::index
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:29
* @route '/driving-license-regex-formats'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/driving-license-regex-formats',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::index
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:29
* @route '/driving-license-regex-formats'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::index
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:29
* @route '/driving-license-regex-formats'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::index
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:29
* @route '/driving-license-regex-formats'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::index
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:29
* @route '/driving-license-regex-formats'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::index
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:29
* @route '/driving-license-regex-formats'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::index
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:29
* @route '/driving-license-regex-formats'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::create
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:41
* @route '/driving-license-regex-formats/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/driving-license-regex-formats/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::create
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:41
* @route '/driving-license-regex-formats/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::create
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:41
* @route '/driving-license-regex-formats/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::create
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:41
* @route '/driving-license-regex-formats/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::create
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:41
* @route '/driving-license-regex-formats/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::create
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:41
* @route '/driving-license-regex-formats/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::create
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:41
* @route '/driving-license-regex-formats/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::store
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:63
* @route '/driving-license-regex-formats'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/driving-license-regex-formats',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::store
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:63
* @route '/driving-license-regex-formats'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::store
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:63
* @route '/driving-license-regex-formats'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::store
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:63
* @route '/driving-license-regex-formats'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::store
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:63
* @route '/driving-license-regex-formats'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::edit
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:72
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}/edit'
*/
export const edit = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/driving-license-regex-formats/{drivingLicenseRegexFormat}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::edit
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:72
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}/edit'
*/
edit.url = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { drivingLicenseRegexFormat: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { drivingLicenseRegexFormat: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            drivingLicenseRegexFormat: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        drivingLicenseRegexFormat: typeof args.drivingLicenseRegexFormat === 'object'
        ? args.drivingLicenseRegexFormat.id
        : args.drivingLicenseRegexFormat,
    }

    return edit.definition.url
            .replace('{drivingLicenseRegexFormat}', parsedArgs.drivingLicenseRegexFormat.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::edit
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:72
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}/edit'
*/
edit.get = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::edit
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:72
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}/edit'
*/
edit.head = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::edit
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:72
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}/edit'
*/
const editForm = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::edit
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:72
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}/edit'
*/
editForm.get = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::edit
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:72
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}/edit'
*/
editForm.head = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::update
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:95
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}'
*/
export const update = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/driving-license-regex-formats/{drivingLicenseRegexFormat}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::update
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:95
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}'
*/
update.url = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { drivingLicenseRegexFormat: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { drivingLicenseRegexFormat: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            drivingLicenseRegexFormat: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        drivingLicenseRegexFormat: typeof args.drivingLicenseRegexFormat === 'object'
        ? args.drivingLicenseRegexFormat.id
        : args.drivingLicenseRegexFormat,
    }

    return update.definition.url
            .replace('{drivingLicenseRegexFormat}', parsedArgs.drivingLicenseRegexFormat.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::update
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:95
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}'
*/
update.put = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::update
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:95
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}'
*/
const updateForm = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::update
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:95
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}'
*/
updateForm.put = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::destroy
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:104
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}'
*/
export const destroy = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/driving-license-regex-formats/{drivingLicenseRegexFormat}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::destroy
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:104
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}'
*/
destroy.url = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { drivingLicenseRegexFormat: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { drivingLicenseRegexFormat: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            drivingLicenseRegexFormat: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        drivingLicenseRegexFormat: typeof args.drivingLicenseRegexFormat === 'object'
        ? args.drivingLicenseRegexFormat.id
        : args.drivingLicenseRegexFormat,
    }

    return destroy.definition.url
            .replace('{drivingLicenseRegexFormat}', parsedArgs.drivingLicenseRegexFormat.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::destroy
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:104
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}'
*/
destroy.delete = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::destroy
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:104
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}'
*/
const destroyForm = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\DrivingLicenseRegexFormats\DrivingLicenseRegexFormatController::destroy
* @see app/Http/Controllers/Admin/DrivingLicenseRegexFormats/DrivingLicenseRegexFormatController.php:104
* @route '/driving-license-regex-formats/{drivingLicenseRegexFormat}'
*/
destroyForm.delete = (args: { drivingLicenseRegexFormat: string | { id: string } } | [drivingLicenseRegexFormat: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const drivingLicenseRegexFormats = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default drivingLicenseRegexFormats